import { StackScreenProps } from "@react-navigation/stack";
import React from "react";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useCategoryById, useProductsByCategory } from "@/hooks/domain/productCategory";
import { HomeNavigation, HomeStackParamList } from "@/navigation/stacks/HomeStack";

import CategoryProductListMobile from "./CategoryProductList.mobile";
import CategoryProductListWeb from "./CategoryProductList.web";

type ScreenProps = StackScreenProps<HomeStackParamList, "categoryProductList">;

const CategoryProductList = ({ route }: ScreenProps) => {
  const categoryId = route.params?.categoryId;

  const { isWebMode } = useViewport();

  const { goBack, navigate, setOptions } = useAppNavigation<HomeNavigation>();

  const { data: category, isLoading: isLoadingCategory } = useCategoryById(categoryId, {
    onSuccess: (data) => {
      setOptions({ title: data?.nome });
    },
    onError: () => {
      goBack();
    },
  });

  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } = useProductsByCategory(
    {
      categoryId,
      limit: isWebMode ? 16 : 10,
      options: {
        enabled: !!categoryId,
      },
    }
  );

  const onLoadMoreProducts = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };

  const onSelectProduct = (productId: string) => {
    navigate("product", { productId });
  };

  const Screen = isWebMode ? CategoryProductListWeb : CategoryProductListMobile;

  return (
    <Screen
      category={category}
      products={data}
      isLoading={isLoading || isLoadingCategory}
      isLoadingMore={isFetchingNextPage}
      onGoBack={() => goBack()}
      onViewMore={() => onLoadMoreProducts()}
      onSelectProduct={onSelectProduct}
    />
  );
};

export default CategoryProductList;
